import React, { useContext } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../../constants/text';
import { LocationContext } from '../../../../../ContextProviders';
import { safeGet } from '../../../../../../../core/util/object';
import { shouldRender } from './util';
import Copy from './Copy';
import { hasBoost } from '../../../../../../../core/util/location';

const Root = styled.div.withConfig({ componentId: 'sc-mcecfr-0' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  color: ${colors.blueMonday};
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  className?: string;
};

const RecentlyBooked = (props: Props) => {
  const { location: physicalLocation, associatedTelemedLocation } = useContext(LocationContext);
  const { className } = props;

  const physicalLocationRecentBookings = safeGet(physicalLocation, 0)('recentBookings');
  const associatedTelemedLocationRecentBookings = safeGet(
    associatedTelemedLocation,

    0
  )('recentBookings');

  if (
    !hasBoost(physicalLocation) ||
    !shouldRender(
      physicalLocation,
      physicalLocationRecentBookings,
      associatedTelemedLocationRecentBookings
    )
  ) {
    return null;
  }

  return (
    <Root className={className} data-testid="recent-bookings-wrapper">
      <Copy
        associatedTelemedLocationRecentBookings={associatedTelemedLocationRecentBookings}
        physicalLocationRecentBookings={physicalLocationRecentBookings}
      />
    </Root>
  );
};

export default RecentlyBooked;
